$(document).ready(function(){
  $(".footer_text-wrapper").click(function(){
    $(".newsletter-form__field-wrapper").slideDown("slow");
  });
});


$(document).ready(function(){
$('.readmore').click(function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.product-description-full');
  descriptionFull.style.display = 'block';
  var descriptionShort = document.querySelector('.product-description-short');
  descriptionShort.style.display = 'none';
});
$('.readless').click(function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.product-description-full');
  descriptionFull.style.display = 'none';
  var descriptionShort = document.querySelector('.product-description-short');
  descriptionShort.style.display = 'block';
});  
  });




$(document).ready(function(){

$('.readmore').click(function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.product-description-full');
  descriptionFull.style.display = 'block';
  var descriptionShort = document.querySelector('.product-description-short');
  descriptionShort.style.display = 'none';
});
$('.readless').click(function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.product-description-full');
  descriptionFull.style.display = 'none';
  var descriptionShort = document.querySelector('.product-description-short');
  descriptionShort.style.display = 'block';
});  
 });

$(document).ready(function(){

// Select all anchor elements
var links = $("a");

// Loop through each link element
$.each(links, function(index, link) {
  // Check if the link's href attribute starts with "http" and is not on the current domain
  if (link.href.indexOf("http") === 0 && link.hostname !== window.location.hostname) {
    // Add the target="_blank" attribute to open the link in a new tab
    $(link).attr("target", "_blank");
  }
});
  });


$(document).ready(function() {
  $('.section-block-template--18266414416192__5c6d6580-a4ce-4146-8f12-c666352487ee .adaptive_height, .section-block-template--18266414416192__5c6d6580-a4ce-4146-8f12-c666352487ee a.text').click(function(event) {
    event.preventDefault();
    var url = $(this).attr('href');
    window.open(url, '_blank');
  });
});


